import { useState } from 'react'
import { parseAsString, useQueryState } from 'nuqs'

// A list's typed search, mirrored into `?search=` so Back restores it (USA-1358). The box
// reads its own state, never the URL, so a URL write landing mid-word cannot drop keys.
export function useUrlSearchText() {
  const [urlSearch, setUrlSearch] = useQueryState('search', parseAsString.withDefault(''))
  const [search, setSearch] = useState(urlSearch)
  const update = (value: string) => {
    setSearch(value)
    void setUrlSearch(value)
  }
  return [search, update] as const
}
